import {Button, Stack} from '@mui/material';
import React from 'react';

export interface BaseActionButton {
  color?:
    | 'inherit'
    | 'error'
    | 'warning'
    | 'success'
    | 'info'
    | 'primary'
    | 'secondary';
  variant?: 'text' | 'outlined' | 'contained';
  title: string;
  icon?: React.ReactNode;
  loading?: boolean;
  onClick?: () => void;
  hidden?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit';
}

export interface BaseActionsProps {
  actions?: BaseActionButton[];
}

// Every real usage of this action bar is document-signing related (see
// DocumentsViewer) and wants Resurs teal, pill-shaped buttons stacked
// vertically on every breakpoint — that matches the Figma design for both
// mobile and desktop pre-review actions, so there's no per-breakpoint
// branching here beyond spacing/padding.
export const BaseFullPageActions: React.FC<BaseActionsProps> = ({actions}) => {
  const filteredActions = actions?.filter((a) => !a.hidden);
  if (!filteredActions?.length) return null;

  return (
    <Stack spacing={1.5} width={'100%'} px={2} pt={2}>
      {filteredActions.map((a) => (
        <Button
          fullWidth
          size="large"
          key={a.title}
          variant={a.variant ?? 'contained'}
          color={a.color ?? 'primary'}
          startIcon={a.icon}
          onClick={a.onClick}
          disabled={a.disabled}
          type={a.type ?? 'button'}>
          {a.title}
        </Button>
      ))}
    </Stack>
  );
};
